export default __webpack_public_path__ + "static/media/labios-gruesos.4bbaf6be.png";